import { render, staticRenderFns } from "./toast-with-mask.mpx?vue&type=template&id=564f2352&isComponent&outputPath=components%2Ftoast-with-mask6c2f35f0%2Findex"
import script from "./toast-with-mask.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftoast-with-mask6c2f35f0%2Findex"
export * from "./toast-with-mask.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftoast-with-mask6c2f35f0%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports